import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";

export default function CancelledBanner({ periodEnd, onUndone }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const handleUndo = async () => {
    setLoading(true);
    setErr("");
    try {
      await api.post("/billing/undo-cancel");
      onUndone?.();
    } catch (e) {
      const detail =
        e?.response?.data?.detail ||
        e?.response?.data?.stripe?.[0] ||
        e?.response?.data?.subscription?.[0] ||
        e?.message ||
        t("billing.reactivateError");
      setErr(detail);
    } finally {
      setLoading(false);
    }
  };

  const periodEndFormatted = periodEnd
    ? new Date(periodEnd).toLocaleDateString("ro-RO", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    : "—";

  return (
    <div className="rounded border border-amber-500/30 bg-amber-50 dark:bg-amber-900/20 p-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <div className="text-sm font-medium text-amber-800 dark:text-amber-200">
            {t("billing.willCancelOn", { date: periodEndFormatted })}
          </div>
          <div className="text-xs text-amber-700 dark:text-amber-300 mt-1">
            {t("billing.fullAccessUntil")}
          </div>
        </div>
        <button
          onClick={handleUndo}
          disabled={loading}
          className="shrink-0 px-3 py-2 rounded bg-amber-600 text-white text-sm font-medium hover:bg-amber-700 disabled:opacity-50"
        >
          {loading ? t("billing.reactivating") : t("billing.keepSubscriptionBtn")}
        </button>
      </div>
      {err ? (
        <div className="mt-2 text-xs text-red-600">{err}</div>
      ) : null}
    </div>
  );
}
